import Card from 'components/card/Card';
import { FormattedMessage } from 'react-intl';
import CardBody from 'components/card/CardBody';
import VirtualizedList from 'containers/partials/lists/VirtualizedList';
import SortableListHeader from 'components/list/SortableListHeader';
import { SORT_DATA_TYPES, SORT_DIRECTION } from 'utils/sort';
import Message from 'components/message/Message';
import MessageText from 'components/message/MessageText';
import DownloadFileButton from './DownloadFileButton';
import MetaWrapper from 'containers/partials/list-items/MetaWrapper';
import messages from 'messages';

const documents_Columns = [
  {
    key: 'id',
    label: '',
    sortable: false
  },
  {
    key: 'filename',
    label: 'Document name',
    sortable: true,
    dir: SORT_DIRECTION.ASC,
    dataType: SORT_DATA_TYPES.STRING
  },
  {
    key: 'date_created',
    label: 'Creation date',
    default: true,
    sortable: true,
    dir: SORT_DIRECTION.DESC,
    dataType: SORT_DATA_TYPES.STRING
  }
];

const DocumentsList = ({ entityId, files, sortFiles }) => {
  return (
    <>
      {files.length > 0 ? (
        <VirtualizedList
          extraClassNames="c-list--sortable-two-columns-with-button"
          items={files}
          titleLabel={'filename'}
          metaLabel={'date_created'}
          icon={'folder'}
          mediumIcon
          entityId={entityId}
          sortableListHeader={
            <SortableListHeader
              onSort={activeSort => {
                sortFiles(files, [activeSort]);
              }}
              columns={documents_Columns}
            />
          }
          meta={
            <MetaWrapper toggler>
              <DownloadFileButton />
            </MetaWrapper>
          }
          onModal
        />
      ) : (
        <Card empty extraClassNames="u-margin-auto">
          <CardBody empty>
            <Message emptyState={true} icon="browse">
              <MessageText>
                <FormattedMessage {...messages.documentsListEmpty} />
              </MessageText>
            </Message>
          </CardBody>
        </Card>
      )}
    </>
  );
};

export default DocumentsList;
